import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const BootScreen = ({ label = "INITIALISING SPEECHFLOW" }) => (
  <div className="flex min-h-screen items-center justify-center" data-testid="boot-screen">
    <div className="flex flex-col items-center gap-4">
      <span className="h-10 w-10 animate-spin rounded-full border-2 border-[color:var(--au-green)] border-t-transparent" />
      <span className="mono-label">{label}</span>
    </div>
  </div>
);

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <BootScreen />;
  if (!user) return <Navigate to={`/?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};
